import React from "react";
import { Image } from "react-native";
import View from "../ReactNative/View";
import Text from "../ReactNative/Text";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";
import AppTheme from "../../utils/Theme";
import { translate } from "../../utils/Localization/Localization";
import User from "../../data/user/User";
import SVGView from "../../utils/SvgView";
import { IcCheck } from "../../utils/Icons";

interface PremiumArgumentsProps {
    screenSize?: number;
}

const PremiumArguments = (props: PremiumArgumentsProps) => {

    const { screenSize } = props;
    const user: User = User.getInstance();
    const appTheme: AppTheme = new AppTheme();
    const {
        fullScreenWidth,
        availableScreenSize,
        sideMenuSize
    } = useSpecificSize();

    const renderAnimatorDetailsBulletPoint = (bulletListIndex: number): React.JSX.Element[] => {
        let introBulletPoints: React.JSX.Element[] = [];
        let bulletPoints: string[][] = [[
            translate.labels().premium.animator.plans.intro.bullet.one,
            translate.labels().premium.animator.plans.intro.bullet.two,
            translate.labels().premium.animator.plans.intro.bullet.three,
            translate.labels().premium.animator.plans.intro.bullet.four,
            translate.labels().premium.animator.plans.intro.bullet.five
        ], [
            translate.labels().premium.animator.plans.intro.bullet.six,
            translate.labels().premium.animator.plans.intro.bullet.seven
        ]];
        for (const bullet of bulletPoints[bulletListIndex]) {
            introBulletPoints.push(<View key={bullet} style={{ flexDirection: "row", paddingBottom: 10, justifyContent: "flex-start", alignItems: "center", width: "90%" }}>
                <View style={{ justifyContent:"center", alignItems:"center", backgroundColor:"#57537F", borderRadius: appTheme.pixelPerfect(8), width: appTheme.pixelPerfect(16), height: appTheme.pixelPerfect(16), marginEnd: appTheme.pixelPerfect(10) }}>
                    <SVGView Component={IcCheck} color="#FFFFFF" size={appTheme.pixelPerfect(10)} />
                </View>
                <Text style={{ flexShrink: 1, color: appTheme.darkBlue, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7) }}>{bullet}</Text>
            </View>)
        }

        return introBulletPoints;
    }

    const renderTeacherDetailsBulletPoint = (bulletListIndex: number): React.JSX.Element[] => {
        let introBulletPoints: React.JSX.Element[] = [];
        let bulletPoints: string[][] = [[
            translate.labels().premium.teacher.plans.details.bullet.one,
            translate.labels().premium.teacher.plans.details.bullet.two,
            translate.labels().premium.teacher.plans.details.bullet.three,
            translate.labels().premium.teacher.plans.details.bullet.four,
            translate.labels().premium.teacher.plans.details.bullet.five,
            translate.labels().premium.teacher.plans.details.bullet.six
        ], [
            translate.labels().premium.teacher.plans.details.bullet.seven,
            translate.labels().premium.teacher.plans.details.bullet.height,
        ]];
        for (const bullet of bulletPoints[bulletListIndex]) {
            introBulletPoints.push(<View key={bullet} style={{ flexDirection: "row", paddingBottom: 10, justifyContent: "flex-start", alignItems: "center", width: "90%" }}>
                <View style={{ justifyContent:"center", alignItems:"center", backgroundColor:"#57537F", borderRadius: appTheme.pixelPerfect(8), width: appTheme.pixelPerfect(16), height: appTheme.pixelPerfect(16), marginEnd: appTheme.pixelPerfect(10) }}>
                    <SVGView Component={IcCheck} color="#FFFFFF" size={appTheme.pixelPerfect(10)} />
                </View>
                <Text style={{ flexShrink: 1, color: appTheme.darkBlue, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7) }}>{bullet}</Text>
            </View>)
        }

        return introBulletPoints;
    }

    const renderFamilyDetailsBulletPoint = (bulletListIndex: number): React.JSX.Element[] => {
        let introBulletPoints: React.JSX.Element[] = [];
        let bulletPoints: string[][] = [[
            translate.labels().premium.family.plans.details.bullet.one,
            translate.labels().premium.family.plans.details.bullet.two,
            translate.labels().premium.family.plans.details.bullet.three,
            translate.labels().premium.family.plans.details.bullet.four,
            translate.labels().premium.family.plans.details.bullet.five,
            translate.labels().premium.family.plans.details.bullet.six
        ], [
            translate.labels().premium.family.plans.details.bullet.seven,
            translate.labels().premium.family.plans.details.bullet.height,
        ]];
        for (const bullet of bulletPoints[bulletListIndex]) {
            introBulletPoints.push(<View key={bullet} style={{ flexDirection: "row", paddingBottom: 10, justifyContent: "flex-start", alignItems: "center", width: "90%" }}>
                <View style={{ justifyContent:"center", alignItems:"center", backgroundColor:"#FFD77A", borderRadius: appTheme.pixelPerfect(8), width: appTheme.pixelPerfect(16), height: appTheme.pixelPerfect(16), marginEnd: appTheme.pixelPerfect(10) }}>
                    <SVGView Component={IcCheck} color={appTheme.darkBlue} size={appTheme.pixelPerfect(10)} />
                </View>
                <Text style={{ flexShrink: 1, color: appTheme.darkBlue, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7) }}>{bullet}</Text>
            </View>)
        }

        return introBulletPoints;
    }

    if (user.profile === "family") {
        return [
            <Text key="title" style={{ width: "100%", textAlign: "center", color: appTheme.darkBlue, fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(7), marginVertical: 10 }}>{translate.labels().premium.family.plans.details.title}</Text>,
            ...renderFamilyDetailsBulletPoint(0),
            <Text key="and_for_you" style={{ width: "100%", textAlign: "center", color: appTheme.darkBlue, fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(7), marginVertical: 10 }}>{"ET POUR VOUS"}</Text>,
            ...renderFamilyDetailsBulletPoint(1)
        ];
    } else if (user.profile === "teacher") {
        return [
            <Text key="title" style={{ width: "100%", textAlign: "center", color: appTheme.darkBlue, fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(7), marginVertical: 10 }}>{translate.labels().premium.teacher.plans.details.title}</Text>,
            ...renderTeacherDetailsBulletPoint(0),
            <Text key="and_for_you" style={{ width: "100%", textAlign: "center", color: appTheme.darkBlue, fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(7), marginVertical: 10 }}>{"ET POUR VOUS"}</Text>,
            ...renderTeacherDetailsBulletPoint(1)
        ];
    } else if (user.profile === "animator") {
        return [
            <Text key="title" style={{ width: "100%", textAlign: "center", color: appTheme.darkBlue, fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(7), marginVertical: 10 }}>{translate.labels().premium.animator.plans.intro.title}</Text>,
            ...renderAnimatorDetailsBulletPoint(0),
            <Text key="and_for_you" style={{ width: "100%", textAlign: "center", color: appTheme.darkBlue, fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(7), marginVertical: 10 }}>{"ET POUR LES SUPER-ANIMS"}</Text>,
            ...renderAnimatorDetailsBulletPoint(1)
        ];
    }
    return null;

}

export default PremiumArguments;